/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TenantDto } from '../models/TenantDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PublicTenantControllerService {
    /**
     * @returns TenantDto OK
     * @throws ApiError
     */
    public static getAvailableTenants(): CancelablePromise<Array<TenantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/tenants',
        });
    }
}
